import { useTranslation } from 'react-i18next';
import InputLineChart from '../../components/InputLineChart';
import BarChart from '../../components/BarChart';
import TrendHeatmap from './components/TrendHeatmap';

import { Stack, Typography } from '@mui/material';

import { KEY_TO_TEXT, KEY_TO_UNIT, ENVIRONMENTAL_KEY_TO_TEXT, ENVIRONMENTAL_KEY_TO_UNIT, CATEGORICAL } from '../../util/keys';

const TrendCharts = (props) => {
    const { inputData, timeAggType, currencySymbol, environmentalData, energyPriceData, localTimeZone } = props;
    const { t } = useTranslation()

    const keys = [...new Set(inputData.data?.map((series) => series.metadata.key) ?? [])];
    const environmentalKeys = [...new Set(environmentalData.data?.map((series) => series.metadata.key) ?? [])]

    return (
        <Stack>
            {
                keys.filter(gt => !CATEGORICAL.includes(gt)).map(
                    (graphType) => <Stack key={`graph-${graphType}`}>
                        <Typography padding={1} align="center" component="h2" variant="h6" color="primary" gutterBottom>
                            {t(KEY_TO_TEXT[graphType])}{KEY_TO_UNIT[graphType] ? ` [${KEY_TO_UNIT[graphType]}]` : ""}
                        </Typography>
                        <InputLineChart
                            graphType={graphType}
                            data={inputData?.data.filter(
                                (d) => d.metadata.key === graphType
                            )
                            }
                            timestamps={inputData?.timestamps}
                            timeAggType={timeAggType}
                            localTimeZone={localTimeZone}
                        />
                    </Stack>
                )
            }

            {
                keys.filter(gt => CATEGORICAL.includes(gt)).map(
                    (graphType) => <Stack key={`graph-${graphType}`}>
                        <Typography padding={1} align="center" component="h2" variant="h6" color="primary" gutterBottom>
                            {t(KEY_TO_TEXT[graphType])}
                        </Typography>
                        <TrendHeatmap
                            graphType={graphType}
                            data={inputData?.data.filter(
                                (d) => d.metadata.key === graphType
                            )
                            }
                            timestamps={inputData?.timestamps}
                            timeAggType={timeAggType}
                            localTimeZone={localTimeZone}
                        />
                    </Stack>
                )

            }


            {
                (energyPriceData.data?.length > 0) &&
                <Stack>
                    <Typography padding={1} align="center" component="h2" variant="h6" color="primary" gutterBottom>
                        {t("Energy price")} [{currencySymbol}]
                    </Typography>
                    <BarChart
                        data={energyPriceData?.data ?? []}
                        timeAggType={timeAggType}
                        timestamps={energyPriceData?.timestamps}
                        localTimeZone={localTimeZone}
                    />
                </Stack>

            }

            {
                environmentalKeys.map(
                    (graphType) => <Stack key={`graph-${graphType}`}>
                        <Typography padding={1} align="center" component="h2" variant="h6" color="primary" gutterBottom>
                            {t(ENVIRONMENTAL_KEY_TO_TEXT[graphType])}{ENVIRONMENTAL_KEY_TO_UNIT[graphType] ? ` [${ENVIRONMENTAL_KEY_TO_UNIT[graphType]}]` : ""}
                        </Typography>
                        <BarChart
                            data={environmentalData?.data.filter(
                                (d) => d.metadata.key === graphType
                            )
                            }
                            timestamps={environmentalData?.timestamps}
                            timeAggType={timeAggType}
                            name={t(ENVIRONMENTAL_KEY_TO_TEXT[graphType])}
                            localTimeZone={localTimeZone}
                        />
                    </Stack>
                )
            }
        </Stack>
    );
}

export default TrendCharts